<template>
  <div class="settings filters">
    <v-container>
      <div class="card-curvey">
        <h2 class="mb-3">Filters Configuration</h2>
        <v-layout>
          <v-flex xs2>
            <div class="d-flex align-center">
              <label class="black--text">Allow Filters</label>
              <v-switch
                v-model="settings.allowFilters"
                @change="disableFilters"
              ></v-switch>
            </div>

          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="settings.allowFilters">
          <v-flex xs4 v-for="(rule,index) in settings.rules">
            <v-layout class="align-center">
              <label class="black--text">{{rule.label}}</label>
              <v-switch
                v-model="rule.active"
              ></v-switch>
              <v-flex xs4 v-if="index === settings.rules.length-1">
                <v-text-field
                  class="mt-2"
                  outline
                  placeholder="Number of days"
                  v-model="rule.value"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <label>White List</label>
            <v-combobox
              v-model="settings.white_list_users"
              :items="[]"
              chips
              outline
              solo
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  close
                  @input="removeTerm(data.item)"
                >
                  <strong>{{ data.item }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-combobox>
          </v-flex>
        </v-layout>
      </div>


      <v-flex xs12 >
        <v-btn  large round color="primary" @click="updateSettings" :loading="loading">
          Save
        </v-btn>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
  import common from "../utils/common";
  import langIso from "../utils/lang-iso"
  export default {
    name: "filters",
    data () {
      return {
        loading: false,
        allowFilters: true,
        settings:{
          iframe_link:'',
          direct_line:'',
          facebook_access_token:'',
          external_analytics: '',
          external_analytics_second: '',
          nlp: {

          },
          allowFilters: false,
        },
        selectedLang: '',
        selectedEngine: '',
        langIso,
        dialog: false
      }
    },
    mounted() {
      this.getSettings()
    },
    methods: {
      getSettings() {
        this.$http_bot.get('/settings/')
          .then(response=>{
            this.settings = response.data
            if (!this.settings.nlp) {
              this.settings.nlp = {}
            }
            if (!this.settings.allowFilters) {
              this.settings.allowFilters = false
            }
          })
          .catch(error=>{
            if (error.response.status === 401) {
              common.logOut()
            }
          })
      },
      updateSettings() {
        this.loading = true
        this.$http.put('/settings/', {
          bot_id: this.botId,
          settings: this.settings
        })
          .then(response=>{
            this.loading = false
          })
          .catch(error=>{
            if (error.response.status === 401) {
              common.logOut()
              this.loading = false
            }
          })
      },
      disableFilters(){
        if (!this.settings.allowFilters) {
          for (let i=0; i<this.settings.rules.length;i++) {
            this.settings.rules[i].active = false
          }
        }
      },
      removeTerm(term){
        let index = this.settings.white_list_users.indexOf(term)
        this.settings.white_list_users.splice(index,1)
      },
      pushLang () {
        if (!this.settings.nlp[this.selectedLang]) {
          this.settings.nlp[this.selectedLang] = {
            engine: this.selectedEngine,
            min_score: '',
            app_id: '',
            api_key: '',
            hostname: '',
          }
          this.selectedLang = ''
          this.selectedEngine = ''
          this.dialog = false
        }
      },
      deleteLang (lang) {
        delete this.settings.nlp[lang]
        this.selectedLang = ''
        this.$forceUpdate();
      },
      getLang(code) {
        let index = this.langIso.findIndex( item=> {
          return item.code === code
        })
        return this.langIso[index].name
      }
    },
    computed: {
      botId() {
        return this.$store.state.bot.botId
      }
    }
  }
</script>

<style scoped>
  .btn-input {
    height: 45px;
  }
  .add-lang {
    max-width: 500px;
    margin: auto;
  }
</style>

<style>
  .filters .v-chip--removable .v-chip__content{
      background: #dddddd !important;
  }
</style>
